<script lang="ts">
  import Loader from '../../../../custom/Loader.svelte'
  import {isShowSearchLoader} from "../../../../stores";
</script>

{#if $isShowSearchLoader}
  <div class="flex justify-center">
    <Loader />
  </div>
{/if}